module.exports = __webpack_public_path__ + "img/youtube.1831a653.svg";